import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class Label extends Component {
  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return <p className={finalRootClass}>{this.props.children}</p>;
  }
}

Label.propTypes = {
  rootClassname: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Label/index.js